import { ICompany } from './Company.interface';

export const initialState: ICompany = {
  TosUrl: '',
  logo: '',
  backgroundImage: '',
  backgroundStyles: '',
  responsiveStyles: ''
};
